// extracted by mini-css-extract-plugin
module.exports = {"tags-list-container":"tagsList_tags-list-container__2EZUy","each-tag":"tagsList_each-tag__3tWnx"};